
import { RouteObject } from 'react-router-dom';
import { lazy } from 'react';

const Home = lazy(() => import('../pages/home/page'));
const PartnerAccess = lazy(() => import('../pages/partner-access/page'));
const Offers = lazy(() => import('../pages/offers/page'));
const NotFound = lazy(() => import('../pages/NotFound'));

const routes: RouteObject[] = [
  {
    path: '/',
    element: <Home />,
  },
  {
    path: '/acces-partenaires',
    element: <PartnerAccess />,
  },
  {
    path: '/offres',
    element: <Offers />,
  },
  {
    path: '*',
    element: <NotFound />,
  },
];

export default routes;
